import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router } from "@angular/router";
import { Observable } from "rxjs";
import { map, tap } from "rxjs/operators";

import { PERMISSION } from "@app/modules/roles/constants";
import { PermissionService } from "@core/services/permission.service";

@Injectable()
export class PermissionGuard implements CanActivate {
  constructor(protected router: Router, private permissionService: PermissionService) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    const permission = route.data.permission as PERMISSION;
    const permissions = route.data.permissions as PERMISSION[];

    if (permission) {
      return this.permissionService.hasPermission$(permission).pipe(
        tap((hasPermission: boolean) => {
          if (!hasPermission) {
            this.router.navigate(["/dashboard/orders"]);
          }
        }),
        map((hasPermission: boolean) => hasPermission)
      );
    } else if (permissions) {
      return this.permissionService.hasAnyPermission$(permissions).pipe(
        tap((hasPermission: boolean) => {
          if (!hasPermission) {
            this.router.navigate(["/dashboard/orders"]);
          }
        }),
        map((hasPermission: boolean) => hasPermission)
      );
    } else {
      this.router.navigate(["/dashboard/orders"]);
    }
  }
}
